import cloneDeep from 'lodash/cloneDeep';
import mergeWith from 'lodash/mergeWith';

import { ADD_ENTITIES, CLEAR_ENTITIES, CLEAR_ENTITIES_BY_ID, CLEAR_SINGLE_ENTITY, UPDATE_ENTITIES } from './constrants';

const initialState = {};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case ADD_ENTITIES: {
      const models = action.entities;
      const newState = cloneDeep(state);

      if (action.replace) {
        return Object.keys(models).reduce((state, key) => ({ ...state, [key]: models[key] }), newState);
      } else {
        return mergeWith(newState, models);
      }
    }

    case CLEAR_ENTITIES: {
      if (!action.names) {
        return {};
      } else {
        const newState = { ...state };
        action.names.map((n) => delete newState[n]);
        return newState;
      }
    }

    case CLEAR_ENTITIES_BY_ID: {
      const newState = { ...state };
      newState[action.name] = Object.keys(state[action.name]).reduce(
        (e, k) => (action.ids.includes(k) ? e : { ...e, [k]: state[action.name][k] }),
        {},
      );
      return newState;
    }

    case CLEAR_SINGLE_ENTITY: {
      const newState = { ...state };
      delete newState[action.name][action.id];
      return newState;
    }

    case UPDATE_ENTITIES: {
      const newState = cloneDeep(state);

      const models = action.entities.reduce(
        (res, e) => {
          return {
            [action.name]: {
              ...res[action.name],
              [e.id]: e,
            },
          };
        },
        { [action.name]: {} },
      );

      return mergeWith(newState, models);
    }

    default:
      return state;
  }
};
